import { render, staticRenderFns } from "./LearningActivityBar.vue?vue&type=template&id=62289a0c&scoped=true"
import script from "./LearningActivityBar.vue?vue&type=script&lang=js"
export * from "./LearningActivityBar.vue?vue&type=script&lang=js"
import style0 from "./LearningActivityBar.vue?vue&type=style&index=0&id=62289a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62289a0c",
  null
  
)

export default component.exports